import React from 'react';
import styled from 'styled-components';
import { RatingType } from '../../../../store/interactive/types';

const MAX = 7;

interface Props {
  rating: RatingType;
}

export const PollStatus: React.FC<Props> = ({ rating }) => {
  const [offsetLeft, setOffsetLeft] = React.useState(0);
  const [offsetRight, setOffsetRight] = React.useState(1);
  const changeName = (fio: string | null) => {
    if (!fio) return '';
    const names = fio.split(' ');
    return `${names[1]} ${names[0]}`;
  };

  return (
    <Wrapp>
      <div style={{ width: '100%' }}>
        <TableS cellSpacing={0}>
          <thead>
            <tr>
              <th>#</th>
              <th style={{ width: '100%' }}>Учасники</th>
              <th>Загальна кількість балів</th>
            </tr>
          </thead>
          <tbody>
            {rating.rating.map((item, i) => {
              if (MAX * offsetLeft - 1 < i && i < offsetRight * MAX) {
                return (
                  <tr key={`${i}${item.userId}`}>
                    <td>
                      {item.position}
                      <StatusLineS style={{ width: `${(item.points / rating.rating[0].points) * 100}%` }} />
                    </td>
                    <td>{changeName(item.fio)}</td>
                    <td>{item.points}</td>
                  </tr>
                );
              }
              return null;
            })}
          </tbody>
        </TableS>
      </div>
      <Paginator
        num={Math.ceil(rating.rating.length / MAX)}
        onChange={(value) => {
          setOffsetLeft(value);
          setOffsetRight(value + 1);
        }}
      />
    </Wrapp>
  );
};

interface PaginatorProps {
  num: number;
  onChange: (value: number) => void;
}

const Paginator: React.FC<PaginatorProps> = ({ num, onChange }) => {
  const [active, setActive] = React.useState(0);
  const arrNums = Array.from({ length: num });
  return (
    <PaginatorS>
      {arrNums.map((item, i) => (
        <ItemS
          key={i}
          onClick={() => {
            setActive(i);
            onChange(i);
          }}
          active={active === i}
        >
          {i + 1}
        </ItemS>
      ))}
    </PaginatorS>
  );
};

const Wrapp = styled.div`
  padding: 20px 50px;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
`;

const TableS = styled.table`
  width: 100%;

  th,
  td {
    text-align: left;
    &:last-child {
      text-align: center;
    }
  }

  th {
    background: #f5f5f5;
    //color: white;
    padding: 10px 20px;
  }

  td {
    padding: 20px;
    border-bottom: 1px solid #dadada;
  }

  tr {
    position: relative;
  }
`;

const StatusLineS = styled.div`
  display: block;
  width: 100%;
  height: 100%;
  background: green;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0.15;
`;

const PaginatorS = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const ItemS = styled.div<{ active?: boolean }>`
  cursor: pointer;
  margin-right: 10px;
  ${({ active }) =>
    active
      ? `
        color: rgba(26,130,197,1);
      `
      : ``}
`;
